/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationUpdateDTO
 */
export interface OrganizationUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof OrganizationUpdateDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUpdateDTO
     */
    info?: string;
}

/**
 * Check if a given object implements the OrganizationUpdateDTO interface.
 */
export function instanceOfOrganizationUpdateDTO(value: object): value is OrganizationUpdateDTO {
    return true;
}

export function OrganizationUpdateDTOFromJSON(json: any): OrganizationUpdateDTO {
    return OrganizationUpdateDTOFromJSONTyped(json, false);
}

export function OrganizationUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'info': json['info'] == null ? undefined : json['info'],
    };
}

export function OrganizationUpdateDTOToJSON(value?: OrganizationUpdateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'info': value['info'],
    };
}

